import * as React from "react";
import {productListCard} from "insurance/utils";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import {IInsuraceProduct} from "StateInterface";
import {saveSelectedProductIndex} from "insurance/actions";
import ProductDetails from "insurance/components/productDetails";
import {logBranchEvent} from "analytics/branch";
import { logEvent } from "analytics/googleAnalyics";
import {imageBaseUrl} from "config";

interface IConnectProps {
    dispatch?: (action: any) => void;
    userId: number;
    insuranceProducts: IInsuraceProduct[];
    selectedSubProduct: string;
    selectedProductIndex: number;
    isIndividualSelected: boolean;
}
class Products extends React.Component<IConnectProps> {
    constructor(props) {
        super(props);
    }
    public handleProceed = (routePath: string, identifier: string | number, subCategory?: string) => {
        this.props.dispatch(saveSelectedProductIndex(Number(identifier)));
        const branchEventMap = {
            CORONA: "Button_Insurance_COVID",
            HOSPICASH: "Button_Insurance_Hospicash",
            MOSQUITO: "Button_Insurance_Mosquito",
        };
        if (this.props.userId && branchEventMap.hasOwnProperty(subCategory)) {
            logBranchEvent(branchEventMap[subCategory], {userId: this.props.userId});
            logEvent(branchEventMap[subCategory], branchEventMap[subCategory], this.props.userId);
        }

    }
   public componentWillMount() {
        let selectedProductIndex = null;
        this.props.insuranceProducts.forEach((product, index) => {
            if (this.props.selectedSubProduct === product.subCategory && selectedProductIndex === null && this.props.isIndividualSelected === product.isIndividual) {
                this.props.dispatch(saveSelectedProductIndex(Number(index)));
                selectedProductIndex = index;
            }
       });
    }
    public render() {
        const renderProduct = [];
        this.props.insuranceProducts.forEach((product, index) => {
            if (this.props.selectedSubProduct === product.subCategory && this.props.isIndividualSelected === product.isIndividual ) {
                renderProduct.push({
                    heading: product.productTitle,
                    price: product.productPrice,
                    description: product.productName,
                    coverage: product.sumInsured,
                    coverType: product.coverType.label,
                    icon: `${imageBaseUrl}/img/icons/protect_guard.png`,
                    handleClick: this.handleProceed,
                    show: true,
                    identifier: index,
                    selectedIndex: this.props.selectedProductIndex === index,
                    subCategory: product.subCategory,
                });
            }
        });
        return (
            <div style={{minHeight: "90vh", marginTop: "25px", width: "100%"}}>
                    <p className="p-0 mb-1 pl-2" style={{fontWeight: "bold"}}>Products we offer</p>
                    {productListCard(renderProduct)}
                    <ProductDetails/>
            </div>
        );
    }
}
const mapStateToProps = (state: IReduxState): IConnectProps => {
    return {
        userId: state.login.auth.userId,
        selectedSubProduct: state.insurance.selectedSubProduct,
        insuranceProducts: state.insurance.insuranceProducts ? state.insurance.insuranceProducts : [],
        selectedProductIndex: state.insurance.selectedProductIndex,
        isIndividualSelected: state.insurance.isIndividualSelected,
    };
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(Products);
